import type {ExternalStore} from '@phonehq/rtc-core';

export class SwitchableStore<T> implements ExternalStore<T> {
    private inner?: ExternalStore<T>;
    private detach?: () => void;
    private readonly listeners = new Set<() => void>();

    constructor(private readonly fallback: T) {}

    getSnapshot = (): T => (this.inner ? this.inner.getSnapshot() : this.fallback);

    subscribe = (listener: () => void): (() => void) => {
        this.listeners.add(listener);
        return () => {
            this.listeners.delete(listener);
        };
    };

    use(inner: ExternalStore<T> | undefined): void {
        if (inner === this.inner) {
            return;
        }
        this.detach?.();
        this.inner = inner;
        this.detach = inner?.subscribe(() => this.notify());
        this.notify();
    }

    private notify(): void {
        [...this.listeners].forEach(listener => listener());
    }
}
